import { render, staticRenderFns } from "./infoXq.vue?vue&type=template&id=c29c9d32&scoped=true&"
import script from "./infoXq.vue?vue&type=script&lang=js&"
export * from "./infoXq.vue?vue&type=script&lang=js&"
import style0 from "./infoXq.vue?vue&type=style&index=0&id=c29c9d32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29c9d32",
  null
  
)

export default component.exports